import { takeLatest, call, put } from 'redux-saga/effects';
import { GatewayManagementApi } from 'api';
import { apiCallStatus, NOTIFICATION_TYPES } from 'helpers/constants';
import logger from 'helpers/logger';
import { actionTypes, requestType } from './constants';
import { updateFirmwareAction } from './actions';
import { notify } from 'sharedComponents/GeneralNotification';
import { translate } from 'helpers/translateHelper';

function* updateFirmware({ gatewayID }) {
    yield put(updateFirmwareAction(apiCallStatus.LOADING));
    try {
        const response = yield call(GatewayManagementApi.updateFirmware, gatewayID);
        yield put(updateFirmwareAction(apiCallStatus.SUCCESS, response));
        if (response?.remoteCommandResponse?.requestType === requestType.TriggerDCUFirmwareUpdate) {
            notify(translate('ABB.Powertrain.Frontend.gatewayUpdateFirmwareSuccessMessage'), NOTIFICATION_TYPES.SUCCESS);
        } else if (response?.error?.message) {
            notify(translate('ABB.Powertrain.Frontend.gatewayUpdateFirmwareErrorMessage'), NOTIFICATION_TYPES.ERROR, true);
        }
        logger.debug('Update Firmware successfully triggered for gateway: ', gatewayID);
    } catch (err) {
        yield put(updateFirmwareAction(apiCallStatus.ERROR, [], err));
        notify(err?.message, NOTIFICATION_TYPES.ERROR, true);
    }
}
export function* updateFirmwareWatchers() {
    yield takeLatest(actionTypes.UPDATE_FIRMWARE, updateFirmware);
}
